import Vue from 'vue'	//引入vue
import Router from 'vue-router'	//引入vue-router模块
import routes from './routes'	//引入路由配置文件(详见下方routes.js配置)
import config from 'plus/config'
import api from 'plus/api'
import auth from 'plus/auth';
import store from '@/store'
import { Loading, MessageBox } from 'element-ui'
import asyncRouters from './asyncRouters'
import { isWorkWechat } from "@/utils/helper"
const login = q => require.ensure([], () => q(require('../views/login')), 'login');
import { getUrlToken, saveRedirectUrl } from "@/utils/urlTokenLogin";


Vue.use(Router)	//声明安装路由
const router = new Router({
    routes:routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

router["_push"] = router["push"];
router["_back"] = router["back"];
router['action'] = true;

let step = 0;



router["push"] = (target, ext) => {
    setTimeout(() => {
        router['_push'](target);
    })

    step += 1;

    router['action'] = ext === undefined ?
        true :
        ext;
}
var time;
router.back = (ext) => {
    setTimeout(() => {
        router['_back']()
    })
    step -= 1;

    router['action'] = ext === undefined ?
        false :
        ext;
}
router.beforeHooks.unshift((to, from, next) => {
    next()
})


router.beforeEach(async (to, from, next) => {
    const { token, menus } = store.getters
    const whiteRoutes = ['login']

    if (whiteRoutes.includes(to.name)) {
        store.dispatch('updateMenus', [])
        next()
        return
    }
    if (token) {
        if (menus.length) {
            if (to.matched.length === 0) {

                if (from.name === 'login') {
                    next({ name: menus[0].children[0].name })
                    return
                } else {
                    MessageBox.alert('您没有权限访问这个页面', '提示', {
                        confirmButtonText: '确定',
                        confirmButtonClass:'confirmBtn',
                    })
                }
                next({path:'/404'})
                return
            } else {
                next()
            }
        } else {


            const loading = Loading.service({
                lock: true,
                text: '正在获取用户权限',
                spinner: 'el-icon-loading'
            })
            try {
                if (await asyncRouters(router, routes)) {
                    next({ ...to })
                }
            } catch (e) {
                if(isWorkWechat()){
                    sessionStorage.setItem('redirectUrl',window.location.href)
                    const res = await api.login.getRedirectUrl(encodeURIComponent(window.location.origin + window.location.pathname + '#/login'))
                    let workWxOauthUrl = res.data.data
                    window.location.replace(workWxOauthUrl)
                }else{
                    MessageBox.alert('获取权限失败。', '错误', {
                        confirmButtonText: '重试',
                        confirmButtonClass:'confirmBtn',
                        showClose: false,
                        callback: () => {
                            window.location.reload()
                        }
                    })
                    console.error('router.beforeEach', e)
                }
            }
            loading.close()
        }
    } else {
        if (isWorkWechat()) {
            sessionStorage.setItem('redirectUrl',window.location.href)
            const res = await api.login.getRedirectUrl(encodeURIComponent(window.location.origin + window.location.pathname + '#/login'))
            let workWxOauthUrl = res.data.data
            window.location.replace(workWxOauthUrl)
        } else {
            console.log("未登录（localStorage 里没有 token）且不是企业微信环境，地址：",window.location.origin + window.location.pathname) // test
            const urlToken = getUrlToken();
            if (urlToken) {
                saveRedirectUrl();
                next({ name: 'login', query: { token: urlToken } });
                return;
            }
            next({ name: 'login' });
        }
    }
})


router.afterEach((to, from) => {
    // TODO
})
export default router
